<template>
    <a-config-provider :theme="theme">
        <router-view></router-view>
    </a-config-provider>
</template>

<script>
  export default {
    name: 'App'
  }
</script>
<script setup>
import { ref } from 'vue';

const theme = ref({
  token: {
      colorPrimary: '#ff4610',
  }
});
</script>
<style lang="css" scoped>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
</style>